import * as React from "react";

export default function HideWidgetEditor(_props: unknown) {
  return (
    <div className="rounded-md border border-slate-200 bg-slate-50 p-3 text-xs text-slate-600 leading-relaxed">
      <div className="font-semibold text-slate-700 mb-1">Hide Widget</div>
      <div>
        When this workflow&apos;s conditions match on page load, the chat widget will
        not render on the page. No other configuration is needed — this is a
        terminal action.
      </div>
      <div className="mt-2 text-slate-500">
        Pair this with conditions on the <code>Widget Loads on Page</code> trigger
        (for example, URL contains <code>/checkout</code>) to control where the
        widget appears.
      </div>
    </div>
  );
}
